import { memo, useMemo } from "react";

import { type RenderResourceRowCellProps } from ".";
import useIacManagementAnalytics from "../../useIacManagementAnalytics";
import IacManagementTableLink from "../components/Link";
import { IAC_MANAGEMENTS_TABLE_COLUMNS } from "../types";
import IacManagementResourceCell from "../components/ResourceCell";
import useCellCopyAction from "../useCellCopyAction";
import { ResourcesSuggestions } from "../../useIacManagementFilters/constants";

const IacManagementTableResourceRowCellName = memo((props: RenderResourceRowCellProps) => {
  const { row, handleResourceClick } = props;

  const copyAction = useCellCopyAction(ResourcesSuggestions.ResourceName, row.name);
  const actions = useMemo(() => [copyAction], [copyAction]);

  const { analyticPage } = useIacManagementAnalytics();
  return (
    <IacManagementResourceCell {...props} actions={actions}>
      <IacManagementTableLink
        columnId={IAC_MANAGEMENTS_TABLE_COLUMNS.NAME}
        onPress={handleResourceClick}
        analyticsPage={analyticPage}
        analyticsTitle="Resource Clicked"
        analyticsProps={{ driftDetected: !!row.drifted }}
      >
        {row.name}
      </IacManagementTableLink>
    </IacManagementResourceCell>
  );
});

IacManagementTableResourceRowCellName.displayName = "IacManagementTableResourceRowCellName";

export default IacManagementTableResourceRowCellName;
